import {
    addToChainAfter,
    createHandlerChainRunner,
    Handler,
    HandlerWithResult,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { UserBudgetThresholdAmount } from "@theStellarBlueprint/CustomApiModel";
import { PostThresholdAmountAtUserLevel as  PostThresholdAmountAtUserLevelApi} from "@theStellarBlueprint/Services/BudgetThresholdAmountService";
import { CustomApiHandler } from "@theStellarBlueprint/Store/CustomHandlerCreator";

type Parameter={
    customThresholdAmountParameter:UserBudgetThresholdAmount
}& HasOnSuccess & HasOnError<string>;

type HandlerType = CustomApiHandler<Parameter, ServiceResult<any>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await PostThresholdAmountAtUserLevelApi(
        props.apiParameter.customThresholdAmountParameter,
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const budgetThresholdAmountHandler = createHandlerChainRunner(chain, "budgetThresholdAmountHandler");
export default budgetThresholdAmountHandler;